import React, { useState } from "react";
import "../../CSS/loginadmin.css";
import { FaUser, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function LoginAdmin() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch("https://api-tibismart.tifpsdku.com/api/admin/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username_admin: username,
          password_admin: password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || "Login gagal");
        setLoading(false);
        return;
      }

      // simpan data admin (sementara pakai localStorage)
      localStorage.setItem("admin", JSON.stringify(data.admin));

      // redirect ke dashboard admin
      navigate("/");
    } catch (err) {
      setError("Gagal terhubung ke server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src="/assets/logobaruTibiSmart.png"
          alt="TibiSmart Logo"
          className="login-logo"
        />
        <h2 className="login-title">Login Admin</h2>

        <p className="login-subtitle">
          Masuk ke <strong>Panel Administrator TibiSmart</strong> untuk
          mengelola data pengguna, laporan kendala, dan sistem.
        </p>

        <form className="login-form" onSubmit={handleLogin}>
          {error && <p className="error-text">{error}</p>}

          <div className="input-group">
            <FaUser className="input-icon" />
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <FaLock className="input-icon" />
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="remember-forgot">
            <label>
              <input type="checkbox" /> Remember me
            </label>
            <a href="#">Forgot password?</a>
          </div>

          <button type="submit" className="btn-join" disabled={loading}>
            {loading ? "Loading..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginAdmin;
